import { ICommentState } from '../../../CommunicationCard/CallsAndCommentsPanel/useCommentsState';
import { isSameDay } from './isSameDay'

type GetAlreadySelectedTimesParams = {
  commentState: ICommentState[];
  selectedDate: Date;
};

export const getAlreadySelectedTimes = ({
  commentState,
  selectedDate,
}: GetAlreadySelectedTimesParams) =>
  commentState
    .filter(
      (comment) =>
        comment.original?.FollowupAt &&
        isSameDay({ dateA:selectedDate,dateB: new Date(comment.original.FollowupAt)})
    )
    .map((comment) => {
      if (!comment.original?.FollowupAt) return '';

      const _followUpAt = new Date(comment.original.FollowupAt);

      return (
        `${_followUpAt.getHours()}`.padStart(2, '0') +
        `:${`${_followUpAt.getMinutes()}`.padStart(2, '0')}`
      );
    });
